export default {
      id: "dumbbell-usage",
      viewBox: "0 0 26 15",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#dumbbell",
      toString: function () {
        return this.url;
      }
    }